import { FIRM_ROLE, GROUP_ROLE, INTERNAL_ROLE } from './roles.ts'
import { IdeyaRoute } from './router.def.ts'
import { TickerManagement } from '../pages/ticker-management/ticker-management.tsx'
import { UserManagement } from '../pages/user-management/user-management.tsx'
import { MailList } from '../pages/mail-list/mail-list.tsx'
import { FirmManagement } from '../pages/firm-management/firm-management.tsx'
import { OverallRanking } from '../pages/overall-ranking/overall-ranking.tsx'
import { IdeaList } from '../pages/idea-list/idea-list.tsx'
import { Dashboard } from '../pages/summary/dashboard.tsx'
import { Rules } from '../pages/rules/rules.tsx'
import { Disclaimer } from '../pages/disclaimer/disclaimer.tsx'
import { GlobalDisclaimer } from '../pages/disclaimer/global-disclaimer.tsx'
import { Statistics } from '../pages/statistics/statistics.tsx'
import { Logout } from '../pages/logout/logout.tsx'
import { Inactive } from '../pages/inactive/inactive.tsx'

export const login: IdeyaRoute = {
  key: 'login',
  path: '/login',
  title: 'Logging in',
  label: 'Logging in',
  description: 'Login',
  pageType: 'external',
  group: 'login',
  element: <div>Logging in</div>,
}

export const logout: IdeyaRoute = {
  key: 'logout',
  path: '/logout',
  title: 'Logout',
  label: 'Logout',
  description: 'Logout',
  pageType: 'external',
  group: 'auth',
  element: <Logout />,
}

export const idea: IdeyaRoute = {
  key: 'idea',
  path: '/idea',
  title: 'Idea List',
  label: 'Idea List',
  description: 'List of all ideas',
  pageType: 'external',
  group: 'idea',
  element: <IdeaList />,
  allowedFirmRoles: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  deniedGroupRoles: [],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const dashboard: IdeyaRoute = {
  key: 'dashboard',
  path: '/dashboard',
  title: 'Dashboard',
  label: 'Dashboard',
  description: 'Dashboard',
  pageType: 'external',
  group: 'idea',
  element: <Dashboard />,
  allowedFirmRoles: [FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  deniedGroupRoles: [],
  allowedInternalRoles: [],
}

export const overallRanking: IdeyaRoute = {
  key: 'ranking/overall-ranking',
  path: '/ranking/overall-ranking',
  title: 'Overall Ranking',
  label: 'Overall Ranking',
  description: 'Overall Ranking',
  pageType: 'external',
  group: 'ranking',
  element: <OverallRanking />,
  allowedFirmRoles: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  deniedGroupRoles: [],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
  globalCanAccess: false,
}

export const myAchievements: IdeyaRoute = {
  key: 'ranking/my-achievements',
  path: '/ranking/my-achievements',
  title: 'My Achievements',
  label: 'My Achievements',
  description: 'My Achievements',
  pageType: 'external',
  group: 'ranking',
  element: <div>My achievements</div>,
  allowedFirmRoles: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  deniedGroupRoles: [],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
  globalCanAccess: false,
}

export const statistics: IdeyaRoute = {
  key: 'statistics',
  path: '/statistics',
  title: 'Statistics',
  label: 'Statistics',
  description: 'Statistics',
  pageType: 'external',
  group: 'statistics',
  element: <Statistics />,
  allowedFirmRoles: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [GROUP_ROLE.ROLE_CAPTAIN, GROUP_ROLE.ROLE_MANAGER],
  deniedGroupRoles: [GROUP_ROLE.ROLE_CONTRIBUTOR],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const firmManagement: IdeyaRoute = {
  key: 'account-management/firm',
  path: '/account-management/firm',
  title: 'Firm Management',
  label: 'Firm Management',
  description: 'Firm Management',
  pageType: 'internal',
  group: 'account-management',
  element: <FirmManagement />,
  allowedFirmRoles: [],
  allowedGroupRoles: [],
  deniedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const userManagement: IdeyaRoute = {
  key: 'account-management/user',
  path: '/account-management/user',
  title: 'User Management',
  label: 'User Management',
  description: 'User Management',
  pageType: 'internal',
  group: 'account-management',
  element: <UserManagement />,
  allowedFirmRoles: [],
  allowedGroupRoles: [],
  deniedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const mailListManagement: IdeyaRoute = {
  key: 'account-management/mail-list',
  path: '/account-management/mail-list',
  title: 'Mail List Management',
  label: 'Mail List Management',
  description: 'Mail List Management',
  pageType: 'internal',
  group: 'account-management',
  element: <MailList />,
  allowedFirmRoles: [],
  allowedGroupRoles: [],
  deniedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const tickerManagement: IdeyaRoute = {
  key: 'ticker-management',
  path: '/ticker-management',
  title: 'Ticker Management',
  label: 'Ticker Management',
  description: 'Ticker Management',
  pageType: 'internal',
  group: 'ticker-management',
  element: <TickerManagement />,
  allowedFirmRoles: [],
  allowedGroupRoles: [],
  deniedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  allowedInternalRoles: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const rules: IdeyaRoute = {
  key: 'rules',
  path: '/rules',
  label: 'menu.rules',
  title: 'Rules',
  description: 'Rules',
  group: 'rules',
  element: <Rules />,
  pageType: 'external',
  allowedFirmRoles: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  allowedGroupRoles: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  deniedGroupRoles: [],
  allowedInternalRoles: [INTERNAL_ROLE.ROLE_MASTER, INTERNAL_ROLE.ROLE_ADMIN],
  globalCanAccess: false,
}

export const disclaimer: IdeyaRoute = {
  key: 'disclaimer',
  path: '/login/disclaimer',
  label: 'disclaimer',
  title: 'Disclaimer',
  description: 'Disclaimer',
  pageType: 'external',
  group: 'disclaimer',
  element: <Disclaimer />,
}

export const globalDisclaimer: IdeyaRoute = {
  key: 'global-disclaimer',
  path: '/login/global-disclaimer',
  label: 'global-disclaimer',
  title: 'Global Disclaimer',
  description: 'Global Disclaimer',
  pageType: 'external',
  group: 'disclaimer',
  element: <GlobalDisclaimer />,
}

export const inactive: IdeyaRoute = {
  key: 'inactive',
  path: '/inactive',
  label: 'inactive',
  title: 'Inactive',
  description: 'Inactive',
  pageType: 'external',
  group: 'auth',
  element: <Inactive />,
}
